document.addEventListener("turbolinks:load", e => {
  if (document.querySelector('#remove_image') !== null) {
    document.querySelector('#remove_image').addEventListener('ajax:success', e => {
      var parent = document.getElementById('image_box');
      var animal_image = document.getElementById('animal_image');
      parent.removeChild(animal_image);
    })
  }

  var checkboxQuarantine = document.getElementById('animal_spec_ins_quarantine');
  if (checkboxQuarantine) {
    checkboxQuarantine.onload = setQuarantineVisibility();
    checkboxQuarantine.addEventListener('change', setQuarantineVisibility);  
  }

  var checkboxAgeOther = document.getElementById('animal_age_other');
  if (checkboxAgeOther) {
    checkboxAgeOther.onload = setAgeOtherVisibility();
    checkboxAgeOther.addEventListener('change', setAgeOtherVisibility);  
  }

  $(".single-select").on('change', function() {
    $('input[name="' + this.name + '"]').not(this).prop('checked', false);
  });

  $(".animal-age-select").on('change', setAgeOtherVisibility); 


});

function setQuarantineVisibility() {
  var checkbox = document.getElementById('animal_spec_ins_quarantine');
  var details_div = document.getElementById('quarantine_detailed');
  if (checkbox.checked) {
    details_div.classList.remove('d-none');
    details_div.classList.add('d-block');
  } else {
    details_div.classList.remove('d-block');
    details_div.classList.add('d-none');
  }
}

function setAgeOtherVisibility() {
  var checkbox_other = document.getElementById('animal_age_other');
  var age_other = document.getElementById('age_other_section');

  if (checkbox_other.checked) {
    age_other.classList.remove('d-none');
    age_other.classList.add('d-block');
  } else {
    age_other.classList.remove('d-block');
    age_other.classList.add('d-none');
    document.getElementById('animal_age_other_text').value = "";
  }
}